var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6421_32195",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6421_32195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.48235 20C6.07059 20 5.72059 19.8536 5.43235 19.5608C5.14412 19.268 5 18.9124 5 18.4941V7.28366C5 6.86536 5.14412 6.5098 5.43235 6.21699C5.72059 5.92418 6.07059 5.77778 6.48235 5.77778H7.63529V4.64837C7.63529 4.4671 7.69349 4.31373 7.80988 4.18824C7.92682 4.06275 8.07451 4 8.25294 4C8.4451 4 8.59937 4.06275 8.71576 4.18824C8.83271 4.31373 8.89118 4.4671 8.89118 4.64837V5.77778H15.1294V4.62745C15.1294 4.46013 15.1912 4.31373 15.3147 4.18824C15.4382 4.06275 15.5824 4 15.7471 4C15.9255 4 16.0729 4.06275 16.1893 4.18824C16.3062 4.31373 16.3647 4.46013 16.3647 4.62745V5.77778H17.5176C17.9294 5.77778 18.2794 5.92418 18.5676 6.21699C18.8559 6.5098 19 6.86536 19 7.28366V18.4941C19 18.9124 18.8559 19.268 18.5676 19.5608C18.2794 19.8536 17.9294 20 17.5176 20H6.48235ZM6.48235 18.7451H17.5176C17.5863 18.7451 17.6447 18.7208 17.6931 18.6723C17.7408 18.6232 17.7647 18.5638 17.7647 18.4941V10.6301H6.23529V18.4941C6.23529 18.5638 6.25945 18.6232 6.30776 18.6723C6.35553 18.7208 6.41373 18.7451 6.48235 18.7451ZM6.23529 9.37516H17.7647V7.28366C17.7647 7.21394 17.7408 7.15482 17.6931 7.1063C17.6447 7.05722 17.5863 7.03268 17.5176 7.03268H6.48235C6.41373 7.03268 6.35553 7.05722 6.30776 7.1063C6.25945 7.15482 6.23529 7.21394 6.23529 7.28366V9.37516Z",
    fill: "#5C5F62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailingIcon);
export default __webpack_public_path__ + "static/media/trailing-icon.7f399e0da7b2b46fc6ea31dca0696317.svg";
export { ForwardRef as ReactComponent };